import { useEffect, useState } from 'react'
import { validateEmploymentDates } from '../../EnrollmentPeriod/validate'

interface UseCompanyNameValidationProps {
    companyName: string
    brandName: string
    workStartYear: string
    workStartMonth: string
    workEndYear: string | null
    workEndMonth: string | null
    isTenure: boolean
    hasInteractedPeriod: boolean
}

export const useCompanyNameValidation = ({
    companyName,
    brandName,
    workStartYear,
    workStartMonth,
    workEndYear,
    workEndMonth,
    isTenure,
    hasInteractedPeriod,
}: UseCompanyNameValidationProps) => {
    const [isFormValid, setIsFormValid] = useState<boolean>(false)
    const [startDateError, setStartDateError] = useState<string>('')
    const [endDateError, setEndDateError] = useState<string>('')

    useEffect(() => {
        const isCompanyValid = companyName.trim() !== '' && brandName.trim() !== ''
        
        const hasStartDateInput = workStartYear !== '' || workStartMonth !== ''
        const hasEndDateInput = workEndYear !== null && (workEndYear !== '' || (workEndMonth !== null && workEndMonth !== ''))
        const shouldValidatePeriod = hasInteractedPeriod || hasStartDateInput || (!isTenure && hasEndDateInput)

        if (shouldValidatePeriod) {
            const validationResult = validateEmploymentDates({
                workStartYear,
                workStartMonth,
                workEndYear,
                workEndMonth,
                isTenure,
            })

            setIsFormValid(isCompanyValid && validationResult.isValid)
            setStartDateError(validationResult.startDateError)
            setEndDateError(validationResult.endDateError)
        } else {
            setIsFormValid(false)
            setStartDateError('')
            setEndDateError('')
        }
    }, [
        companyName,
        brandName,
        workStartYear,
        workStartMonth,
        workEndYear,
        workEndMonth,
        isTenure,
        hasInteractedPeriod,
    ])

    return {
        isFormValid,
        startDateError,
        endDateError,
    }
}

